export default "__VITE_ASSET__Df8WsWxw__"